import React from 'react'
import cyberBuckVideoDesktop from './cyber-buck-desktop.webm'
import cyberBuckVideoMobile from './cyber-buck-mobile.webm'
import styles from './CyberBuckShowcase.module.scss'

const CyberBuckShowcase: React.FC = () => {
  return (
    <div className={styles.videoContainer}>
      <video
        className={styles.desktopVideo}
        src={cyberBuckVideoDesktop}
        autoPlay
        loop
        muted
        playsInline
      />
      <video
        className={styles.mobileVideo}
        src={cyberBuckVideoMobile}
        autoPlay
        loop
        muted
        playsInline
      />
    </div>
  )
}

export default CyberBuckShowcase
